import { ReactNode } from 'react';
import { Lock } from '@assets/svg';
import { Button, Text } from '@components';
import {
  BackgroundImage,
  BackgroundImageContainer,
  Container,
  ContentContainer,
  IconContainer,
} from './RestrictedProductTab.styles';

export interface RestrictedProductTabProps {
  backgroundImageUrl: string;
  text: ReactNode;
  button?: {
    label: string;
    onClick: () => void;
    iconLeft?: ReactNode;
  };
}

const RestrictedProductTab: React.FC<RestrictedProductTabProps> = ({
  backgroundImageUrl,
  text,
  button,
}: RestrictedProductTabProps) => {
  const { iconLeft: IconLeft } = button ?? {};

  return (
    <Container data-testid='restricted-content-container'>
      <BackgroundImageContainer>
        <BackgroundImage alt='background' src={backgroundImageUrl} />
      </BackgroundImageContainer>
      <ContentContainer>
        <IconContainer>
          <Lock />
        </IconContainer>
        <Text variant='h5' fontWeight='fontWeightMedium'>
          {text}
        </Text>
        {button ? (
          <Button
            data-testid='restricted-content-button'
            variant='primary'
            color='primary'
            startIcon={IconLeft}
            onClick={button.onClick}
          >
            {button.label}
          </Button>
        ) : null}
      </ContentContainer>
    </Container>
  );
};

export default RestrictedProductTab;
